module.exports = __webpack_public_path__ + "static/img/new_about1.48e09c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_about1.png
// module id = L6Su
// module chunks = 1